<template>
  <div>
  <span v-for="pace in optionPaces" :key="pace.id" class="has-text-left training-options">
    <a class="button m-r-sm m-b-sm"
       v-if="(europeanNationality && pace.name === 'Alternance') || pace.name === 'Initial'"
       :class="[selectedPace === pace.id ? 'selected-pace':'']"
       @click="paceChoice(pace)">
      {{ pace.name }}
    </a>
    <a class="button m-r-sm m-b-sm disabled-pace-choice" v-else>
      {{ pace.name }}
    </a>
  </span>
  </div>
</template>

<script>
export default {
  props: {
    optionPaces: Array,
    europeanNationality: Boolean,
    selectedPace: Number
  },
  methods: {
    paceChoice(pace) {
      this.$emit('pace-chosen', pace);
    }
  }
}
</script>
<style scoped>
.selected-pace {
  background-color: #0f1e44;
  color: white;
}
.selected-pace:hover {
  background-color: #0f1e44;
  color: white;
}
.disabled-pace-choice {
  opacity: 0.5;
  pointer-events: none;
}
</style>
